export const changeLevel2NameReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_LEVEL2DATA_NAME":
      return action.payload.level2Data;
    default:
      return state;
  }
};
